import { Order } from 'models/Orders'
import { PurchaseCookieDto } from 'models/Purchase'
import { RootState } from 'redux/store'

import getPaymentSource from '../shared/getPaymentSource'

export const getPurchaseFromOrder = (
  { id, attributes: order }: Order,
  store: RootState,
): PurchaseCookieDto => {
  const paymentSource = getPaymentSource(store.order.paymentDetails.type, store)

  return {
    id,
    comment: order.comment,
    company_match: {
      id: store.order.donationOptions.employerMatchCompanyId ?? undefined,
      name: store.order.donationOptions.employerMatchCompanyName || undefined,
    },
    company_name: order.orderProperties.companyName ?? undefined,
    created_at: order.createdAt,
    currency_code: undefined,
    donation_gross_amount: undefined,
    billing_country: store.order.billingDetails.address.country,
    billing_first_name: store.order.billingDetails.firstName,
    billing_last_name: store.order.billingDetails.lastName,
    billing_postal_code: store.order.billingDetails.address.postalCode,
    frequency: undefined,
    has_dedication: store.order.dedication.hasDedication,
    is_anonymous: order.orderProperties.isAnonymous,
    is_donor_covered_fee: order.donorCoversFees,
    member_email_address: store.order.billingDetails.email,
    member_id: String(order.memberId),
    normalized_fees_covered: undefined,
    overhead_net_amount: undefined,
    payment_source: paymentSource,
    raw_adjustment_amount: order.donorCoveredFee,
    raw_currency_code: order.currency,
    raw_donation_gross_amount: order.grandTotal,
    raw_initial_gross_amount: order.subtotal,
    raw_overhead_net_amount: 0,
    raw_total_gross_amount: String(order.grandTotal),
    supporter_id: order.supporterId,
    total_gross_amount: undefined,
  }
}
